import React from 'react'
import { Trans } from 'react-i18next'
import Font from 'src/components/Core/Typography/Font/Font'
import Accordion from 'src/components/Organisms/Accordion/Accordion'
import utils from '../../../../../components/Organisms/Form/utils'
import t from '../../../../../translations/main'
import { textLink } from './components'

const FAQText = (
  <Font
    key='FAQText'
    ellipsis={false}
  >
    {/* @ts-ignore */}
    {<Trans i18nKey={'onboarding.forms.CorporateAccount.RepresentationsForm.visualOnly.FAQText'}
      components={{ mylink: textLink || null }} /> }
  </Font>
)

const hiddenAccordion = (
  <Accordion
    key='onlyNonFinancialEntities'
    title={t('onboarding.forms.CorporateAccount.RepresentationsForm.visualOnly.onlyNonFinancialEntities.title')}
    margin='0 0 24px 0'
    isOpen>
    {/* @ts-ignore */}
    <Trans i18nKey={'onboarding.forms.CorporateAccount.RepresentationsForm.visualOnly.onlyNonFinancialEntities.content'} />
  </Accordion>
)

const changeOfStatusAccordion = (
  <Accordion
    key='changeOfStatus'
    title={t('onboarding.forms.CorporateAccount.RepresentationsForm.visualOnly.changeOfStatus.title')}
    margin='0 0 24px 0'
    isOpen>
    {/* @ts-ignore */}
    <Trans i18nKey={'onboarding.forms.CorporateAccount.RepresentationsForm.visualOnly.changeOfStatus.content'} />
  </Accordion>
)

const config = utils.injectTranslation({
  id: 'RepresentationsForm',
  path: 'onboarding.forms.CorporateAccount.RepresentationsForm.inputs',
  keysToRemove: ['visual'],
  content: [
    {
      componentType: 'grid',
      props: {
        marginBottom: '16px'
      },
      content: [
        {
          componentType: 'radioButton',
          props: {
            name: 'eTradingDerivativeProduct',
            id: 'financialCounterparty',
            value: 'financialCounterparty',
            //@ts-ignore 
            label: <Trans i18nKey={'onboarding.forms.CorporateAccount.RepresentationsForm.radioOptions.financialCounterparty'}/>,
            display: 'inline',
            minWidth: '24px',
            marginWrapper: '8px 0 0 0'
          },
        },
      ]
    },

    {
      componentType: 'grid',
      props: {
        marginBottom: '16px'
      },
      content: [
        {
          componentType: 'radioButton',
          props: {
            name: 'eTradingDerivativeProduct',
            id: 'smallFinancialCounterparty',
            value: 'smallFinancialCounterparty',
            label: <Trans i18nKey={'onboarding.forms.CorporateAccount.RepresentationsForm.radioOptions.smallFinancialCounterparty'}/>,
            display: 'inline',
            minWidth: '24px',
          },
        },
      ]
    },

    {
      componentType: 'grid',
      props: {
        marginBottom: '16px'
      },
      content: [
        {
          componentType: 'radioButton',
          props: {
            name: 'eTradingDerivativeProduct',
            id: 'nonFinancialCounterpartyAbove',
            value: 'nonFinancialCounterpartyAbove',
            label: <Trans i18nKey={'onboarding.forms.CorporateAccount.RepresentationsForm.radioOptions.nonFinancialCounterpartyAbove'}/>,
            display: 'inline',
            minWidth: '24px',

          },
        },
      ]
    },
    {
      componentType: 'grid',
      props: {
        marginLeft: '4%',
        width: '96%'
      },
      content: [
        {
          componentType: 'radioGroup',
          transformType: 'stringAndBooleanConversion',
          props: {
            name: 'eReasonForYouTradeCommodityDerivaties',
            minHeight: '0',
            flex: {
              flexDirection: 'column'
            },
            dataList: [
              {
                id: 'eReasonForYouTradeCommodityDerivaties1',
                label: t('onboarding.forms.CorporateAccount.RepresentationsForm.radioOptions.hiddenRadioGroupOptions.i'),
                value: 'hedgingPurposes',
                minWidth: '24px'
              },
              {
                id: 'eReasonForYouTradeCommodityDerivaties2',
                label: t('onboarding.forms.CorporateAccount.RepresentationsForm.radioOptions.hiddenRadioGroupOptions.ii'),
                value: 'speculativePurposes',
                minWidth: '24px'
              },
              {
                id: 'eReasonForYouTradeCommodityDerivaties3',
                label: t('onboarding.forms.CorporateAccount.RepresentationsForm.radioOptions.hiddenRadioGroupOptions.iii'),
                value: 'hedgingAndSpeculativePurposes',
                minWidth: '24px'
              },
            ],
            removeLabelEllipsis: true,
            required: true,
          },
          secondaryName: 'eReasonForYouTradeCommodityDerivaties-nonFinancialCounterpartyAbove'
        },
        {
          componentType: 'accordion',
          visualComponent: hiddenAccordion,
          visualName: 'nonFinancialCounterpartyAbove-accordion'
        },
      ]
    },

    {
      componentType: 'grid',
      props: {
        marginBottom: '16px'
      },
      content: [
        {
          componentType: 'radioButton',
          props: {
            name: 'eTradingDerivativeProduct',
            id: 'nonFinancialCounterpartyBelow',
            value: 'nonFinancialCounterpartyBelow',
            label: <Trans i18nKey={'onboarding.forms.CorporateAccount.RepresentationsForm.radioOptions.nonFinancialCounterpartyBelow'}/>,
            display: 'inline',
            minWidth: '24px',
          },
        },
      ]
    },
    {
      componentType: 'grid',
      props: {
        marginLeft: '4%',
        width: '96%'
      },
      content: [
        {
          componentType: 'radioGroup',
          transformType: 'stringAndBooleanConversion',
          props: {
            name: 'eReasonForYouTradeCommodityDerivaties',
            minHeight: '0',
            flex: {
              flexDirection: 'column'
            },
            dataList: [
              {
                id: 'eReasonForYouTradeCommodityDerivaties1',
                label: t('onboarding.forms.CorporateAccount.RepresentationsForm.radioOptions.hiddenRadioGroupOptions.i'),
                value: 'hedgingPurposes',
                minWidth: '24px'
              },
              {
                id: 'eReasonForYouTradeCommodityDerivaties2',
                label: t('onboarding.forms.CorporateAccount.RepresentationsForm.radioOptions.hiddenRadioGroupOptions.ii'),
                value: 'speculativePurposes',
                minWidth: '24px'
              },
              {
                id: 'eReasonForYouTradeCommodityDerivaties3',
                label: t('onboarding.forms.CorporateAccount.RepresentationsForm.radioOptions.hiddenRadioGroupOptions.iii'),
                value: 'hedgingAndSpeculativePurposes',
                minWidth: '24px'
              },
            ],
            removeLabelEllipsis: true,
            required: true,
          },
          secondaryName: 'eReasonForYouTradeCommodityDerivaties-nonFinancialCounterpartyBelow'
        },
        {
          componentType: 'accordion',
          visualComponent: hiddenAccordion,
          visualName: 'nonFinancialCounterpartyBelow-accordion'
        },
      ]
    },

    {
      componentType: 'grid',
      props: {
        rowGap: '16px'
      },
      content: [
        {
          componentType: '',
          visualComponent: FAQText
        },
        {
          componentType: 'accordion',
          visualComponent: changeOfStatusAccordion,
        },
      ]
    }
  ],
})

export default config
